import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { createTask } from '../../../../redux/api/tasksApi';
import { createVisitTaskAction } from '../../../../redux/actions/visitTasksActions';
import { convertToVisitTaskRequest } from '../../../../utils/requestMapper';
import Button from '../../../shared/buttons/Button';
import Modal from '../../../shared/modal/Modal';
import VisitTaskForm from '../forms/VisitTaskForm';

const CreateVisitTaskModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const { vin, id, rate } = useSelector((state) => state.visit.visit);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);

    if (data.taskName) {
      const { error, data: newTask } = await createTask({ name: data.taskName, hours: data.hours });
      if (error) {
        toast.error(error?.message || 'Не вдалося створити послугу');
        setLoading(false);
        return;
      }
      data.task = { id: newTask.id };
    }

    const task = convertToVisitTaskRequest(data);
    await dispatch(createVisitTaskAction(vin, id, task));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Додати послугу'}
      loading={loading}
      onClose={onModalClose}
      body={
        <VisitTaskForm
          readOnly={false}
          onSubmit={onSubmit}
          loading={loading}
          task={{ rate: rate, isCritical: false }}
        />
      }
      actionButton={
        <Button
          type={'submit'}
          disabled={loading}
          variant={'primary'}
          formId={'visitTask-form'}
          children={'Зберегти'}
        />
      }
    />
  );
};

export default CreateVisitTaskModal;
